import axios, { AxiosError } from 'axios'

import { NavigateFunction } from 'react-router'
import { ROUTE_PATHS } from '../app/appRoutes'

export const navigateToRootIfNotFoundError = (
  navigate: NavigateFunction,
  error: any
) => {
  if (error && axios.isAxiosError(error)) {
    const axiosError: AxiosError = error
    if (axiosError?.response?.status === 404) {
      navigate(ROUTE_PATHS.ROOT)
    }
  }
}
